var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIconFive4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15845 64.4955L18.751 16.1234C18.9006 15.7101 19.1522 15.3414 19.4823 15.0513C19.8125 14.7611 20.2105 14.5591 20.6396 14.4639C21.0686 14.3686 21.5148 14.3833 21.9367 14.5065C22.3585 14.6297 22.7425 14.8574 23.0529 15.1686L53.8357 45.9514C54.146 46.2621 54.3729 46.646 54.4954 47.0677C54.6179 47.4893 54.6321 47.9351 54.5365 48.3637C54.441 48.7923 54.2389 49.1898 53.9489 49.5195C53.6589 49.8492 53.2904 50.1004 52.8775 50.2499L4.50543 67.8425C4.03829 68.0131 3.53212 68.0468 3.04652 67.9394C2.56091 67.832 2.11609 67.5882 1.76442 67.2365C1.41276 66.8848 1.16889 66.44 1.06153 65.9544C0.954178 65.4688 0.987801 64.9626 1.15845 64.4955Z",
    fill: "#D1A97A",
    stroke: "#D1A97A",
    strokeWidth: 1.51699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8779 19.7618C43.8779 19.7618 43.8779 11.721 51.9187 11.721C59.9595 11.721 59.9595 3.68018 59.9595 3.68018",
    stroke: "#D1A97A",
    strokeWidth: 1.51699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8379 1V9.0408",
    stroke: "#D1A97A",
    strokeWidth: 1.51699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.96 33.1631L65.3205 38.5236",
    stroke: "#D1A97A",
    strokeWidth: 1.51699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.96 22.4422L68.0008 19.762",
    stroke: "#D1A97A",
    strokeWidth: 1.51699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8887 33.5696L35.4304 53.1113",
    stroke: "#1B2429",
    strokeWidth: 1.51699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4724 57.764L11.2363 47.5278",
    stroke: "#1B2429",
    strokeWidth: 1.51699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIconFive4);
export default __webpack_public_path__ + "static/media/service-icon-five-4.07194fca6080d9fbd2767b719ae47012.svg";
export { ForwardRef as ReactComponent };